import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-post-login-layout',
  templateUrl: './post-login-layout.component.html',
  styleUrl: './post-login-layout.component.css',
})
export class PostLoginLayoutComponent {
}
